module.exports = __webpack_public_path__ + "static/incentivo-ea0c06594f4907fba30c9687a9300daf.png";